interface BackBarProps {
  onBack: () => void;
}

/**
 * Dedicated row above the red banner holding a single back control.
 * Shared across the RSVP step pages (Child, Fighter, Variant).
 */
export function BackBar({ onBack }: BackBarProps) {
  return (
    <div className="smash-back-bar">
      <button
        type="button"
        className="smash-back-bar__btn"
        onClick={onBack}
        aria-label="Go back"
      >
        <svg
          className="smash-back-bar__icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M11 4 L3 12 L11 20 M3 12 H21" />
        </svg>
      </button>
    </div>
  );
}
